import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQueryWithReauth } from '../apiSlice'
import { IGetAllExperts, TCreateExpertInput } from './model'
import { formDataCreate } from '../../../utils/formDataUpload/formDataUpload'
import { IMessageAndStatusCode } from '../admin/model'
import { ISearchParams } from '../../../global.model'

export const expertApis = createApi({
  reducerPath: 'exports/api',
  baseQuery: baseQueryWithReauth,
  endpoints: build => ({
    getAllExperts: build.query<IGetAllExperts, ISearchParams | void>({
      query: (params: ISearchParams) => ({ url: '/admin/expert', params })
    }),
    getExpertById: build.query<TCreateExpertInput, number>({
      query: (expertId: number) => `/admin/expert/${expertId}`
    }),
    createExpert: build.mutation<IMessageAndStatusCode, TCreateExpertInput>({
      query: expertData => ({
        url: '/admin/expert',
        method: 'POST',
        body: formDataCreate(expertData)
      })
    }),
    updateExpert: build.mutation<IMessageAndStatusCode, TCreateExpertInput>({
      query: expertData => ({
        url: `/admin/expert/${expertData.id}`,
        method: 'PUT',
        body: formDataCreate(expertData)
      })
    }),
    deleteExpertById: build.mutation<{ message: string }, string>({
      query: (expertId: string) => ({
        url: `/admin/expert/${expertId}`,
        method: 'DELETE'
      })
    })
  })
})
export const {
  useGetAllExpertsQuery,
  useGetExpertByIdQuery,
  useCreateExpertMutation,
  useUpdateExpertMutation,
  useDeleteExpertByIdMutation
} = expertApis
